const     Web3 = () => {
  return (
    <section className="relative h-[600px] sm:h-[800px] lg:h-[1000px]" id="Web3">
      {/* Background Video */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          poster="/static/videos/CHPbackground4s.mp4"
        >
          <source src="/static/videos/CHPbackground4s.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10 h-full flex items-center">
        <div className="w-full lg:w-1/2 text-white text-center lg:text-left">
          <div className="space-y-2">
            <div className="uppercase leading-tight">
              <p className="animate-slide-in text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wider" style={{ animationDelay: '0.3s', animationFillMode: 'forwards', letterSpacing: '0.2em' }}>
                Smart Contract Security,
              </p>
              <p className="animate-slide-in opacity-0 font-light text-3xl sm:text-4xl lg:text-5xl tracking-wider" style={{ animationDelay: '0.6s', animationFillMode: 'forwards', letterSpacing: '0.2em' }}>
                Powered by a Global Audit Army
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Web3;